document.addEventListener("DOMContentLoaded", () => {

  const grid = document.getElementById("xpro-products");
  const filterInputs = document.querySelectorAll(".xpro-filter-input");
  const priceRange = document.getElementById("xpro-price-range");
  const priceValue = document.getElementById("xpro-price-value");
  const clearBtn = document.getElementById("xpro-clear-filters");
  const noProductsMsg = document.getElementById("xpro-no-products");
  const loadMoreBtn = document.getElementById("xpro-load-more"); // Botón nuevo

  if (!grid) return;

  // --- CONFIGURACIÓN DE PAGINACIÓN ---
  let visibleLimit = 12; // Cuántos productos se ven inicialmente
  const increment = 12;  // Cuántos más se muestran al dar clic
  let allCards = Array.from(grid.querySelectorAll(".product-card"));

  const activeFilters = {
    categoria: [],
    vendor: [],
    raza: [],
    edad: [],
    tamano: [],
    price: null
  };

  /* =========================
      INICIALIZACIÓN
  ========================= */
  const init = () => {
    if (priceRange && allCards.length > 0) {
      const prices = allCards.map(c => parseFloat(c.dataset.price || 0));
      const maxProductPrice = Math.max(...prices);
      priceRange.max = maxProductPrice;
      priceRange.value = maxProductPrice;
      activeFilters.price = maxProductPrice;
      priceValue.textContent = `$${maxProductPrice.toLocaleString("es-CO")}`;
    }
    
    restoreFromURL();
    applyFilters();
    updateCounter();
  };

  /* =========================
      LÓGICA DE FILTRADO
  ========================= */
  filterInputs.forEach(input => {
    input.addEventListener("change", () => {
      const type = input.dataset.filterType;
      const val = input.dataset.filterValue;

      if (input.checked) {
        if (!activeFilters[type].includes(val)) activeFilters[type].push(val);
      } else {
        activeFilters[type] = activeFilters[type].filter(v => v !== val);
      }

      visibleLimit = 12; // Resetear paginación al cambiar filtros
      handleFilterChange();
    });
  });

  if (priceRange) {
    priceRange.addEventListener("input", () => {
      activeFilters.price = parseInt(priceRange.value);
      priceValue.textContent = `$${activeFilters.price.toLocaleString("es-CO")}`;
      visibleLimit = 12; // Resetear paginación
      handleFilterChange();
    });
  }

  /* =========================
      APLICAR FILTROS Y PAGINACIÓN
  ========================= */
  const applyFilters = () => {
    let matchCount = 0; // Productos que pasan los filtros

    allCards.forEach(card => {
      let isVisible = true;

      // 1. Filtrado por Atributos
      for (const key of ["categoria", "vendor", "raza", "edad", "tamano"]) {
        if (activeFilters[key].length > 0) {
          const cardValues = card.dataset[key] ? card.dataset[key].split(',') : [];
          const match = activeFilters[key].some(filterVal => cardValues.includes(filterVal));
          if (!match) { isVisible = false; break; }
        }
      }

      // 2. Filtrado por Precio
      if (isVisible && activeFilters.price !== null) {
        if (parseFloat(card.dataset.price || 0) > activeFilters.price) isVisible = false;
      }

      // 3. Aplicar Paginación (Ver Más)
      if (isVisible) {
        matchCount++;
        // Solo mostrar si está dentro del límite de paginación actual
        card.style.display = (matchCount <= visibleLimit) ? "block" : "none";
      } else {
        card.style.display = "none";
      }
    });

    // Control del botón "Ver más"
    if (loadMoreBtn) {
      // Si hay más productos de los que estamos mostrando, enseñar el botón
      loadMoreBtn.parentElement.style.display = (matchCount > visibleLimit) ? "block" : "none";
    }

    if (noProductsMsg) {
      noProductsMsg.style.display = (matchCount === 0) ? "block" : "none";
    }

    toggleClearButton();
  };

  /* =========================
      EVENTO "VER MÁS"
  ========================= */
  loadMoreBtn?.addEventListener("click", () => {
    visibleLimit += increment; // Aumentamos el límite
    applyFilters(); // Re-aplicamos (esto mostrará los siguientes productos)
  });

  /* =========================
      UTILIDADES
  ========================= */
  const handleFilterChange = () => {
    applyFilters();
    updateCounter();
    syncURL();
  };

  const toggleClearButton = () => {
    if (!clearBtn) return;
    const hasActiveFilters = Object.values(activeFilters).some(v => 
      Array.isArray(v) ? v.length > 0 : (v !== null && priceRange && v < priceRange.max)
    );
    clearBtn.style.display = hasActiveFilters ? "inline-block" : "none";
  };

  const updateCounter = () => {
    const counter = document.getElementById("xpro-result-count");
    if (!counter) return;

    // Contamos TODOS los productos que pasan el filtro (no solo los visibles)
    const totalMatch = allCards.filter(card => {
        let isVisible = true;
        for (const key of ["categoria", "vendor", "raza", "edad", "tamano"]) {
            if (activeFilters[key].length > 0) {
                const cardValues = card.dataset[key] ? card.dataset[key].split(',') : [];
                if (!activeFilters[key].some(f => cardValues.includes(f))) isVisible = false;
            }
        }
        if (isVisible && activeFilters.price && parseFloat(card.dataset.price) > activeFilters.price) isVisible = false;
        return isVisible;
    }).length;

    counter.textContent = `${totalMatch} productos encontrados`;
  };

  const resetFilters = () => {
    Object.keys(activeFilters).forEach(k => {
      activeFilters[k] = Array.isArray(activeFilters[k]) ? [] : (priceRange ? priceRange.max : null);
    });
    filterInputs.forEach(input => input.checked = false);
    if (priceRange) {
      priceRange.value = priceRange.max;
      priceValue.textContent = `$${parseInt(priceRange.max).toLocaleString("es-CO")}`;
    }
    visibleLimit = 12; // Resetear paginación
    handleFilterChange();
  };

  if (clearBtn) clearBtn.addEventListener("click", resetFilters);

  const syncURL = () => {
    const params = new URLSearchParams();
    Object.keys(activeFilters).forEach(k => {
      if (Array.isArray(activeFilters[k]) && activeFilters[k].length) {
        params.set(k, activeFilters[k].join(","));
      } else if (k === "price" && priceRange && activeFilters.price < priceRange.max) {
        params.set("price", activeFilters.price);
      }
    });
    const newRelativePathQuery = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    history.replaceState(null, "", newRelativePathQuery);
  };

  const restoreFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    params.forEach((v, k) => {
      if (activeFilters[k] !== undefined) {
        if (k === "price") {
          activeFilters[k] = parseInt(v);
          if (priceRange) priceRange.value = v;
        } else {
          activeFilters[k] = v.split(",");
          activeFilters[k].forEach(val => {
            const input = document.querySelector(`.xpro-filter-input[data-filter-type="${k}"][data-filter-value="${val}"]`);
            if (input) input.checked = true;
          });
        }
      }
    });
  };

  init();
});